module.exports = __webpack_public_path__ + "static/42gde-6fe1fcf339982d59d4a61f101fb6b42c.gif";